// 公共方法类
// this.$commonUtil.xx() 调用

export default {
  test () {
    console.log("test")
  },
  formatPrice (val) {
    if (!val) return ''
    return val / 100
  },
  deepCopy (obj) {
    return JSON.parse(JSON.stringify(obj))
  },
  isObjNull (obj) {
    return JSON.stringify(obj) == '{}'
  },
  // 验证邮箱有效性
  isEmailAvailable (emailInput) {
    var myreg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    if (!myreg.test(emailInput)) {
      return false
    }
    return true
  },
  isLogin () {
    if (localStorage.getItem('partnerInfo')) {
      return true
    }
    return false
  },
  getAccountPermission (permissionKey) {
    let partnerInfo = JSON.parse(localStorage.getItem('partnerInfo'))
    if (!partnerInfo) {
      return false
    }
    if (!partnerInfo.accountPermission) return false
    let permissions = JSON.parse(partnerInfo.accountPermission)
    return permissions[permissionKey]
  },
  getPartnerInfo () {
    if (localStorage.getItem('partnerInfo')) {
      return JSON.parse(localStorage.getItem('partnerInfo'))
    } else {
      return null
    }
  },
  localStorageSetItem (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  localStorageGetItem (key) {
    if (localStorage.getItem(key)) {
      return JSON.parse(localStorage.getItem(key))
    }
    return null
  },
  formatGuestName (str) {
    if (!str) {
      return ''
    }
    return str.replace(/\(.*?\)/g, '')
  },
  formatGuestNameForBooking (guestName) {
    if (guestName.length) {
      let nameString = ''
      guestName.forEach(item => {
        nameString += item + "  "
      });
      return nameString;
    } else {
      return nameString;
    }
  },
  modfiyicon () {
    let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = '../static/img/b2b-icon.png'
  },
  getRegionIdBySHotelId (sHotelId) {
    return sHotelId % 10 === 1
  },
  getRegionBySHotelId (sHotelId) {
    return sHotelId % 10
  },
  getScoreDesc (score) {
    score = Number(score)
    if (!score) return '不错'
    if (score <= 4.4) return '不错'
    if (score === 4.5 || score === 4.6) return `${score}很好`
    return `${score}超棒`
  },
  getCategoryDesc (category) {
    category = Number(category)
    if (!category) return '经济型'
    if (category <= 2) return '经济型'
    if (category === 3) return '舒适型'
    if (category === 4) return '高档型'
    if (category === 5) return '豪华型'
  },
  getCnStr(cn, en) {
    if (!cn && !en) return ''
    return cn || en
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/CommonUtil.js